export default __webpack_public_path__ + "static/media/perfexdatalogo.9ddc9886.png";